import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Top-level shell that hosts the PFP nav bar + the lazy-loaded child outlet.
 * Kept dumb on purpose: each tab is a `routerLink` so deep links continue to
 * work and the back/forward buttons behave naturally.
 */
@Component({
  selector: 'lohi-ppp-shell',
  templateUrl: './ppp-shell.component.html',
  styleUrls: ['./ppp-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PppShellComponent {}
